import { fabric } from "fabric";

const objectPriority = {
  labelCanvas: 0,
  iconsHelperLine: 1,
  iText: 2,
  curveText: 2,
  svgShape: 2,
  image: 2,
  clipArt: 2,
  group: 2,
  flyerTopLayer: 3,
  bleedLine: 4,
  safeZone: 4,
  actualLabelSize: 4,
  objectIconUnlock: 5,
  objectIconLock: 5,
  objectIconDelete: 5,
  objectIconArrange: 5,
  snapLineGroup: 5,
  guidelinesBtn: 5
} as { [key: string]: number };

export const arrangeObjectStack = (canvas: fabric.Canvas): void => {
  canvas._objects.sort((a, b) => {
    const aName = a.name as string;
    const bName = b.name as string;

    if (objectPriority[aName] < objectPriority[bName]) {
      return -1;
    } else if (objectPriority[aName] === objectPriority[bName]) {
      return 0;
    } else {
      return 1;
    }
  });

  canvas.renderAll();
};

export const moveUserObjectToBack = (canvas: fabric.Canvas, object: fabric.Object) => {
  const canvasObjects = canvas.getObjects() as fabric.Object[];

  //Only user added canvas objects have number ids
  //Find first user added object and use its stack place to 'send-to-back'
  let position = 0;
  for (let i = 0; i < canvasObjects.length; i++) {
    if (!Number.isNaN(Number(canvasObjects[i].id))) {
      position = i;
      break;
    }
  }

  if (position === 1) {
    canvas.moveTo(object, 1);
  } else if (position > 1) {
    canvas.moveTo(object, position - 1);
  }
};
